import { CellAction } from "./cell-action";

import { ColumnDef } from "@tanstack/react-table";

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "title",
    header: "TITRE",
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
